import React, { useContext } from "react";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import { CheckCircleOutline, RadioButtonUnchecked, Save } from "@material-ui/icons";
import { BrandContext } from "../../../contexts/BrandContext";
import BasicInputField from "../form/BasicInputField";
import { getValidationFromFields, initialValues } from "../form/FormUtilities";
import { TaxiBookingContext } from "./BookTaxiContext";
import { serializePickupTime } from "./BookTaxiUtilities";
import BlurHandler from "./BlurHandler";


export default function PickupTimeSetter(props){

    const taxiBookingContext = useContext(TaxiBookingContext);
    const brandContext = useContext(BrandContext);
    
    const {
        focusKey='',
        setFocus,
    } = taxiBookingContext;

    

    const {
        textContent:{
            pickupTimeLabel='',
            widget_saveButton:save=''
        },
    } = brandContext;

    const {
        titleLabel='',
        bookingHook='',
    } = props;

    const isFocused = bookingHook === focusKey;

    const formFields = {
        'asapOrAdvance':{
            label:titleLabel,
            type: 'radioButton',
            options:[
                {
                    value:'1',
                    label:'asap'
                },
                {
                    value:'2',
                    label:'laterToday'
                },
                {
                    value:'3',
                    label:'advanceLabel'
                }
            ],
            default:'1',
            required:false,
        },
        'travelTime': {
            'label': 'travelTimeFormLabel',
            'type':'timePicker',
            'default':new Date(),
            required:false,
        },
        'travelDate': {
            'label': 'taxiTrackingDate',
            'type':'datePicker',
            'default':new Date(),
            required:false,
        },
        
    }
    
    const bookingDataObject = taxiBookingContext.bookingData[bookingHook];
    const {isSubmitted} = bookingDataObject;

    const sectionReady = (formik) => {
        const{
            errors
        } = formik;
        if((Object.keys(errors).length === 0) && isSubmitted){
            return true;
        }
        return false;
    }

    return (
            
        <Formik
                initialValues={initialValues(formFields)}
                validationSchema={getValidationFromFields(formFields)}
                onSubmit={(values)=>{
                    bookingDataObject.data = values;
                    bookingDataObject.isSubmitted = true;
                    taxiBookingContext.setState({
                        focusKey:''
                    });
                    taxiBookingContext.checkTaxiAvailability();
                }}
            >
                {formikProps => (
                    
                        <Card 
                            variant="outlined" 
                            className={`${isFocused && 'sectionFocused'} ${sectionReady(formikProps) && 'sectionReady'} lightBox sectionBox`} 
                            onFocus={()=>{
                                if(!isFocused){
                                    setFocus(bookingHook)
                                }
                            }}
                            onClick={()=>{
                                if(!isFocused){
                                    setFocus(bookingHook)
                                }
                            }}
                        >

                            {isFocused ?
                                <Box>
                                    <form onSubmit={formikProps.handleSubmit}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={12}>
                                                <BasicInputField
                                                    sx={{width:'100%'}}  
                                                    formik={formikProps}
                                                    formFields={formFields} 
                                                    fieldName="asapOrAdvance"
                                                    className="boldLabel"
                                                />    
                                            </Grid>
                                            {formikProps.values.asapOrAdvance !== '1' &&
                                                <Grid item xs={12} md={12}>
                                                    <BasicInputField
                                                        sx={{
                                                            width:'100%'}}  
                                                        
                                                        formik={formikProps}
                                                        formFields={formFields} 
                                                        fieldName="travelTime"
                                                    />    
                                                </Grid>
                                            }
                                            {formikProps.values.asapOrAdvance === '3' &&
                                                    <Grid item xs={12} md={12}>
                                                    <BasicInputField
                                                        sx={{
                                                            width:'100%'}}  
                                                        
                                                        formik={formikProps}
                                                        formFields={formFields} 
                                                        fieldName="travelDate"
                                                    />    
                                                </Grid>
                                            }
                                        </Grid>
                                    </form>        
                                </Box>
                            :
                                <Box className="sectionSummary">
                                    {sectionReady(formikProps) ?
                                        <Box className="iconContainer iconReady"><CheckCircleOutline/></Box>
                                    :
                                        <Box className="iconContainer"><RadioButtonUnchecked/></Box>
                                    }
                                    <Typography variant="subtitle1">{pickupTimeLabel} {serializePickupTime(bookingDataObject.data)}</Typography>
                                </Box>
                            }
                            <Box sx={{paddingTop:1}}>
                                {isFocused &&
                                    <>
                                    <Button
                                        sx={{width:'100%', marginLeft:0}}
                                        size="small"    
                                        startIcon={<Save/>}
                                        variant="contained"
                                        type="submit"
                                        onClick={()=>{formikProps.handleSubmit()}}
                                        >
                                        {save}
                                    </Button>
                                    </>
                                }
                            </Box>
                        </Card>  
                       
                )}
        </Formik>
    );

    


}